import React from 'react';
import './Loading.css';
import loadingIcon from '../../loading.png';

function Loading() {
  return (
    <div className="loading-container">
      <img src={loadingIcon} alt="Loading..." className="loading-spinner" />
    </div>
  );
}

export default Loading;

